import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

const FORECAST_TREE_KEY = ['forecasts', 'tree'];

function useForecastMutation(mutateFn) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: mutateFn,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: FORECAST_TREE_KEY });
      // Invalide aussi le cash-flow car les prévisionnels l'alimentent
      qc.invalidateQueries({ queryKey: ['cash-flow'] });
    },
  });
}

/**
 * Crée un prévisionnel.
 * Payload : { mode, category_id, ...champsSpécifiquesAuMode }
 */
export function useCreateForecast() {
  return useForecastMutation((body) => api.post('/forecasts', body));
}

/**
 * Met à jour un prévisionnel.
 * Payload : { mode, id, ...patch }
 */
export function useUpdateForecast() {
  return useForecastMutation(({ mode, id, ...patch }) =>
    api.patch(`/forecasts/${mode}/${id}`, patch)
  );
}

/**
 * Supprime un prévisionnel.
 * Payload : { mode, id }
 */
export function useDeleteForecast() {
  return useForecastMutation(({ mode, id }) =>
    api.delete(`/forecasts/${mode}/${id}`)
  );
}
